'use strict';

export default function($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/appstore", "/appstore/list");

  $stateProvider
    .state('appstore', {
      url: '/appstore',
      template: require('./appstore.html'),
      authenticate: true
    })
    .state('appstore.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'AppStoreListController',
      controllerAs: 'asListCtrl'
    })
    .state('appstore.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'AppStoreShowController',
      controllerAs: 'asShowCtrl'
    })
    .state('appstore.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'AppStoreAddController',
      controllerAs: 'asAddCtrl'
    })
    .state('appstore.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'AppStoreEditController',
      controllerAs: 'asEditCtrl'
    })
    .state('appstore.addconf', {
      url: '/addconf/:id',
      template: require('./addConf/addConf.html'),
      controller: 'AppStoreAddConfController',
      controllerAs: 'asAddConfCtrl'
    })
    .state('appstore.editconf', {
      url: '/editconf/:id',
      template: require('./editConf/editConf.html'),
      controller: 'AppStoreEditConfController',
      controllerAs: 'asEditConfCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/appstore/appstore.routes.js